import React, {Fragment, useEffect, useState} from "react";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { viewDetailsColumn} from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";

function ViewDetails({data}) {
    const [loading, setLoading] = useState(false);
    const [tblData, setTblData] = useState([]);
    
    useEffect(() => {
        if (data) {
            setTblData(data.Items);
        }
    }, [data]);

    return (
        <Fragment>
            <BackDropLoading loading={loading} />
            <RemoteTable
                data={tblData}
                columns={viewDetailsColumn}
                noTitle
                showPagination={false}
            />

        </Fragment>
    );
}

export default ViewDetails;
